const RenderLoadingScreen = () => {

}

export default RenderLoadingScreen;